import { URL_API_PRODUCT } from 'src/config';
import httpService from 'src/helpers/httpService';
import baseActions from '../baseActions';

const path = 'categories';
export const actionType = (action) => {
  return {
    request: `${action}_${path}_request`.toUpperCase(),
    success: `${action}_${path}_success`.toUpperCase(),
    error: `${action}_${path}_error`.toUpperCase(),
  };
};

const category = {
  ...baseActions(URL_API_PRODUCT, path, actionType),
  fetchAll: (params) => {
    const http = httpService();
    return (dispatch) => {
      dispatch({ type: actionType('fetchAll').request });
      return http.get(`${URL_API_PRODUCT}/categories`, { params: { ...params, status: true } }).then(
        (response) => {
          dispatch({ type: actionType('fetchAll').success, response: response.data });
          return response.data;
        },
        (error) => {
          dispatch({ type: actionType('fetchAll').error });
          throw error.response;
        },
      );
    };
  },
};
export default category;
